import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { HotToastService } from "@ngneat/hot-toast";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { EmailService } from "src/app/dashboard/email/email.service";
import { ImapConfigComponent } from "src/app/dashboard/email/imap-config/imap-config.component";
import { SharedDataService } from "src/app/dashboard/shared-data.service";

@Component({
    selector: "app-connect-email",
    templateUrl: "./connect-email.component.html",
    styleUrls: ["./connect-email.component.css"],
    imports: [CommonModule, RouterModule, BsDropdownModule]
})
export class ConnectEmailComponent {
  constructor(
    private emailService: EmailService,
    public modalService: BsModalService,
    private route: ActivatedRoute,
    public sharedDataService: SharedDataService,
  ) {}

  private toastr = inject(HotToastService);
  public bsModalRef: BsModalRef;
  inboxes: any = [];
  inboxState: string = null;
  loading = true;

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.emailService.getInboxList().subscribe((res) => {
        console.log("inbox list", res);
        this.inboxes = res;

        if (this.inboxes.length > 0) {
          this.emailService.getInboxSettings(this.inboxes[0].uuid);

          this.emailService
            .getInboxState(
              this.sharedDataService.user.email,
              this.inboxes[0].uuid,
            )
            .subscribe(
              (res) => {
                console.log("inbox state", res);
                this.inboxState = res["state"];
                this.loading = false;
              },
              (err) => {
                console.log(err);
                this.loading = false;
                this.inboxState = null;
              },
            );
        } else {
          this.loading = false;
          this.inboxState = null;
        }
      });
    });
  }

  getAuthUrl(provider) {
    if (provider == "google") {
      this.bsModalRef = this.modalService.show(ImapConfigComponent);

      this.bsModalRef.content.onClose.subscribe((sub) => {
        console.log("onClose", sub);
        if (sub == "new" || sub == "existing") {
          this.inboxState = "syncing";
        }
      });
      return;
    }

    this.emailService.getAuthUrl(provider, {}).subscribe((res: any) => {
      console.log(res);
      (window as Window).location = res.url;
    });
  }

  retryConnection() {
    this.emailService.retryConnection().then(
      (res) => {
        console.log(res);
        this.inboxState = null;
        this.inboxes = [];
      },
      (err) => {
        this.toastr.error(
          "Couldn't retry connection. Please reach out to support.",
        );
      },
    );
  }
}
